module.exports = __webpack_public_path__ + "static/assets/65d1b12c52fe97d8d5f3d79b3fecb48b.svg";